<template>
  <!-- 带远程搜索的select -->
  <Select
    :multiple="multiple"
    :max-tag-count="1"
    :disabled="disabled"
    @on-change="change"
    @on-select="select"
    clearable
    filterable
    :placeholder="placeholder"
    v-model="currentValue"
    :loading="loading"
    :transfer="transfer || false"
    :remote-method="queryEntry"
    @on-query-change="keyword = $event"
  >
    <slot :list="list"></slot>
  </Select>
</template>

<script>
import _ from 'lodash';
export default {
  props: {
    value: null,
    disabled: null,
    defaultLabel: null,
    multiple: null,
    placeholder: {
      default: '请选择'
    },
    transfer: null,
    remoteMethod: null
  },
  components: {},
  data() {
    return {
      timer: null,
      loading: false,
      initDone: false,
      initSending: false,
      keyword: '',
      list: []
    };
  },
  watch: {},
  computed: {
    currentValue: {
      // 动态计算currentValue的值
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    change(id) {
      this.$emit('change', id);
    },
    // data={value:id,label:name}
    select(data) {
      this.$emit('select', data);
    },
    // 查询入口
    queryEntry(keyword) {
      if (this.initDone) {
        this.keywordChange(keyword)
      } else {
        this.init(keyword);
      }
    },
    // 编辑表单初始化时会多次触发，防止多次请求
    init(keyword) {
      if(this.initSending){
        return;
      }
      this.initSending = true;
      this.keyword = keyword;
      this.reload();
    },
    // 输入关键词 防抖，输入结束调用
    keywordChange: _.debounce (
      function (keyword) {
        this.keyword = keyword;
        this.reload();
      },
      500,
      { leading: false, trailing: true }
    ),
    async getData(keyword) {
      if (typeof this.remoteMethod === 'function') {
        this.loading = true;
        const list = await this.remoteMethod(keyword);
        this.loading = false;
        if (list) {
          this.list = list;
        }
      }
      // 编辑表单初始化时会多次触发，延迟解锁避免多次请求
      window.setTimeout(() => {
        this.initSending = false;
        this.initDone = true;
      }, 500);
    },
    // 刷新时调用
    reload() {
      this.getData(this.keyword);
    }
  }
};
</script>
<style lang="scss"></style>
